import BasePage from '../../../../components/table_page';
import Form from './form';

export default {
  extends: BasePage,
  data() {
    return {};
  },
  created() {
    this.getConfigList('process_monitor_list');
  },
  components: {
    Form,
  },
  methods: {
    modalClick({ val, row }) {
      const { code, name } = val;
      if (code === 'add' || code === 'edit' || code === 'view') {
        this.modalConfig.title = name || '查看';

        this.formConfig = {
          code,
          row,
        };
        this.openDrawer();
      }
    },
  },
};
